import React from 'react';
import PropTypes from 'prop-types';

import colors from 'customizations/js/color-variables';

export const IconTournaments = ({ className, color }) => (
  <svg
    className={className}
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="icon-filled-path icon-stroked-path"
      d="M20.3767 7.63211C20.5492 7.67609 20.7307 7.70012 20.9184 7.70012C22.0246 7.70012 22.9246 6.88287 22.9246 5.87831C22.9246 4.87379 22.0246 4.05654 20.9184 4.05654C19.8122 4.05654 18.9122 4.87375 18.9122 5.87831C18.9122 6.02718 18.9325 6.17179 18.9697 6.31035L15.1711 8.00818L13.1449 4.19865C13.6509 3.8676 13.9813 3.32838 13.9813 2.72002C13.9813 1.7155 13.0813 0.898254 11.9751 0.898254C10.8689 0.898254 9.96898 1.71551 9.96898 2.72007C9.96898 3.32466 10.2952 3.86105 10.796 4.19261L8.76516 8.00818L4.96958 6.31176C5.04577 6.1195 5.08755 5.91243 5.08755 5.69663C5.08755 4.69212 4.18763 3.87487 3.0814 3.87487C1.97521 3.87487 1.0752 4.69207 1.0752 5.69663C1.0752 6.70115 1.97516 7.51844 3.0814 7.51844C3.22468 7.51844 3.36441 7.50445 3.49929 7.47842L5.83352 15.6307V18.4243C5.83352 18.7984 6.13679 19.1016 6.51087 19.1016L17.4177 19.1016C17.7918 19.1016 18.0951 18.7983 18.0951 18.4242V15.6501L20.3767 7.63211ZM20.9184 5.41951C21.197 5.41951 21.4237 5.62531 21.4237 5.87835C21.4237 6.13136 21.197 6.33725 20.9184 6.33725C20.6398 6.33725 20.4131 6.1314 20.4131 5.87835C20.4131 5.62531 20.6398 5.41951 20.9184 5.41951ZM3.08145 6.15548C2.80279 6.15548 2.57611 5.94959 2.57611 5.69659C2.57611 5.44358 2.80279 5.23774 3.08145 5.23774C3.36006 5.23774 3.58674 5.44354 3.58674 5.69659C3.58674 5.94959 3.36011 6.15548 3.08145 6.15548ZM11.9751 2.26117C12.2537 2.26117 12.4805 2.46702 12.4805 2.72007C12.4805 2.97311 12.2538 3.17891 11.9751 3.17891C11.6965 3.17891 11.4698 2.97311 11.4698 2.72007C11.4698 2.46702 11.6965 2.26117 11.9751 2.26117ZM7.33439 17.8828V16.1945H16.5942V17.8828H7.33439ZM16.8227 14.8316H7.11356L5.28556 7.97202L8.43345 9.37894C8.90129 9.58804 9.45149 9.40965 9.70762 8.9658L11.9681 5.04866L14.2287 8.96581C14.4848 9.40965 15.035 9.58804 15.5028 9.37895L18.6507 7.97202L16.8227 14.8316Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);

IconTournaments.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

IconTournaments.defaultProps = {
  className: null,
  color: colors.gray10,
};
